/**
 * Color Swatches JavaScript
 * Handles interactions for metafield-based color swatches
 */

document.addEventListener('DOMContentLoaded', function() {
  // Initialize color swatch functionality
  initializeColorSwatches();

  // Maintain size selection across color changes
  maintainSizeSelection();
});

/**
 * Initialize color swatch interactions
 */
function initializeColorSwatches() {
  const colorSwatches = document.querySelectorAll('.color-swatch');

  colorSwatches.forEach(swatch => {
    // Add click tracking for analytics
    swatch.addEventListener('click', function(e) {
      const productId = this.dataset.productId;
      const colorName = this.getAttribute('title');

      // Track color selection event (for analytics)
      if (window.Shopify && window.Shopify.analytics) {
        window.Shopify.analytics.publish('color_swatch_clicked', {
          productId: productId,
          colorName: colorName
        });
      }

      // If it's a single swatch (no navigation), prevent default
      if (this.classList.contains('color-swatch--single')) {
        e.preventDefault();
        return;
      }

      // Preserve size selection in URL
      const currentUrl = new URL(window.location.href);
      const currentSize = currentUrl.searchParams.get('size');

      if (currentSize) {
        const targetUrl = new URL(this.href);
        targetUrl.searchParams.set('size', currentSize);
        this.href = targetUrl.toString();
      }
    });

    // Add hover preview for product cards
    if (swatch.closest('product-card')) {
      swatch.addEventListener('mouseenter', function() {
        previewProductImage(this);
      });

      swatch.addEventListener('mouseleave', function() {
        resetProductImage(this);
      });
    }
  });
}

/**
 * Maintain size selection across color changes
 */
function maintainSizeSelection() {
  // Check if there's a size parameter in the URL
  const urlParams = new URLSearchParams(window.location.search);
  const selectedSize = urlParams.get('size');

  if (selectedSize) {
    // Try to select the corresponding size variant
    const sizeSelectors = document.querySelectorAll('input[name*="Size"], select[name*="Size"]');

    sizeSelectors.forEach(selector => {
      if (selector.type === 'radio' || selector.type === 'checkbox') {
        if (selector.value === selectedSize) {
          selector.checked = true;
          // Trigger change event to update variant selection
          selector.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } else if (selector.tagName === 'SELECT') {
        selector.value = selectedSize;
        selector.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  // Add size parameter to color swatch links when size is selected
  const sizeInputs = document.querySelectorAll('input[name*="Size"], select[name*="Size"]');

  sizeInputs.forEach(input => {
    input.addEventListener('change', function() {
      updateColorSwatchLinks(this.value);
    });
  });
}

/**
 * Update color swatch links with selected size
 */
function updateColorSwatchLinks(size) {
  const colorSwatches = document.querySelectorAll('.color-swatch');

  colorSwatches.forEach(swatch => {
    if (swatch.href) {
      const url = new URL(swatch.href);
      if (size) {
        url.searchParams.set('size', size);
      } else {
        url.searchParams.delete('size');
      }
      swatch.href = url.toString();
    }
  });
}

/**
 * Preview product image on hover (for collection pages)
 */
function previewProductImage(swatch) {
  const productCard = swatch.closest('product-card');
  if (!productCard) return;

  const productId = swatch.dataset.productId;
  if (!productId) return;

  // Find the main product image in the card
  const mainImage = productCard.querySelector('.product-card__image img');
  if (!mainImage) return;

  // Store original image for restoration
  if (!mainImage.dataset.originalSrc) {
    mainImage.dataset.originalSrc = mainImage.src;
    mainImage.dataset.originalSrcset = mainImage.srcset;
  }

  // Fetch product data to get the main image
  fetch(`/products/${productId}.js`)
    .then(response => response.json())
    .then(product => {
      if (product.featured_image) {
        mainImage.src = product.featured_image;
        mainImage.srcset = '';
      }
    })
    .catch(error => {
      console.error('Error fetching product data:', error);
    });
}

/**
 * Reset product image after hover
 */
function resetProductImage(swatch) {
  const productCard = swatch.closest('product-card');
  if (!productCard) return;

  const mainImage = productCard.querySelector('.product-card__image img');
  if (!mainImage || !mainImage.dataset.originalSrc) return;

  // Restore original image
  mainImage.src = mainImage.dataset.originalSrc;
  mainImage.srcset = mainImage.dataset.originalSrcset || '';
}

/**
 * Web Component for color selector (if needed for enhanced functionality)
 */
if (customElements && !customElements.get('color-selector')) {
  class ColorSelector extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', this.onColorSelect.bind(this));
    }

    onColorSelect(event) {
      const swatch = event.target.closest('.color-swatch');
      if (!swatch || swatch.classList.contains('color-swatch--active')) return;

      // Update active state visually (before navigation)
      const allSwatches = this.querySelectorAll('.color-swatch');
      allSwatches.forEach(s => s.classList.remove('color-swatch--active'));
      swatch.classList.add('color-swatch--active');
    }
  }

  customElements.define('color-selector', ColorSelector);
}